// Multilingual content: NL / EN / UK
// Kept in one file for simplicity — expand freely.

const en = {
  brand: { name: "Sunbraider", project: "Reiki for Ukraine" },
  nav: {
    home: "Home",
    reiki: "What is Reiki",
    mission: "Mission & Ukraine",
    fundraiser: "Fundraiser",
    book: "Book a Session",
    support: "Support Isa",
    future_services: "Future Offerings",
    future_interest: "Future Interest",
    certificates: "Certificates",
    contact: "Contact",
    explore: "Explore",
    promo: "Promo material",
    login: "Sign in",
    register: "Create account",
    dashboard: "My account",
    admin: "Admin",
    logout: "Sign out",
    book_cta: "Book a Session",
  },
  home: {
    eyebrow: "A Sunbraider beginning",
    title_line1: "Reiki, in service of Ukraine.",
    title_line2: "80% onward to Ukraine.",
    lede:
      "This is the first chapter of Sunbraider: a mission-led Reiki practice rooted in presence, integrity, and compassion. Every session has a real Reiki price — **80% is transferred to Ukraine (via Dzyga's Paw); 20% supports my path so I can keep offering this work**. Selling life energy itself does not resonate with me; sending the greater part onward does.",
    cta_book: "Book a session",
    cta_reiki: "Read: what is Reiki",
    trust_title: "A serious beginning of a long journey",
    trust_body:
      "Sunbraider is my personal practice and lifelong direction. Right now the work is intentionally free — a way to build experience, deepen presence, and support Ukraine. Future stages will bring teaching, embodiment, and a premium wellness practice — but only when the ground is truly ready.",
    phases_title: "Three phases, one path",
    phase1_title: "Now — Free Reiki & Ukraine",
    phase1_body: "Free chair-Reiki sessions at home. Focus on experience, trust, and mission. Support for Ukraine.",
    phase2_title: "Later — Teaching & Learning",
    phase2_body: "Reiki teaching and embodiment courses. Early supporters gather points that later become useful gifts and Sunbraider merchandise — no discounts, because the practice deserves to be taken seriously.",
    phase3_title: "Much later — Sunbraider Wellness Clinic",
    phase3_body: "A wellness clinic focused on emotional wellbeing — energy work, NEI biotensor, light acupuncture, massage, and face/hair/hand treatments. Reiki and other energetic healing will then be offered at full price so the business can stand on its own. Our support to Ukraine continues throughout — we keep everyone posted on every donation and every effort. Not a glow-up you wear, a glow-up you become.",
    ukraine_title: "Standing with Ukraine",
    ukraine_body:
      "If Reiki is a language of harmony, then peace and freedom are its native soil. In cooperation with Dzyga's Paw, part of every session travels onward to Ukraine so that harmony has ground to stand on.",
    ukraine_cta: "Learn about the mission",
    certificates_teaser: "Trained, tested, and committed",
    certificates_teaser_body: "A gallery of certificates and trainings — because trust is built with transparency.",
    certificates_cta: "See certificates",
  },
  reiki: {
    eyebrow: "A living practice",
    title: "What is Reiki",
    intro:
      "Reiki is the universal life energy that moves through everything that lives, breathes, and rests. To practise Reiki is not to invent something new — it is to remember what is already flowing, and to allow it to flow more clearly.",
    sections: [
      {
        h: "Between contrast and unity",
        p: "Everything we experience arrives through contrast — light and shadow, sound and silence, tension and ease. Reiki is not the removal of contrast. It is the felt memory that beneath every polarity there is one continuous field. When the body remembers this, it softens on its own.",
      },
      {
        h: "The body as a listening field",
        p: "Our body is not only tissue — it is an intelligent, sensitive, energetic field. Stress teaches us to armour; presence teaches us to open. In a Reiki session, the body is given space to lay down its defenses without being asked to explain them.",
      },
      {
        h: "Presence, touch and calm",
        p: "There is a form of touch that does not take, and there is a form of presence that does not demand. Reiki is offered from that place. Sometimes hands rest lightly on the shoulders, sometimes they hover, sometimes there is simply the quality of attention — always without agenda.",
      },
      {
        h: "A way of living, not only a technique",
        p: "Reiki is not merely something you do for an hour. It is a posture toward life — a willingness to be with what is here, to trust the intelligence in the flow, and to move from calm rather than from urgency. This is why the sessions I offer now are free: the practice nourishes me already.",
      },
      {
        h: "A quiet reminder",
        p: "Every session is a small remembering — of harmony, of connectedness, of the fact that the essential in us was never broken, only tired. That is the invitation I extend to you, in Sunbraider' first chapter.",
      },
    ],
  },
  mission: {
    eyebrow: "The mission",
    title: "Why free, why now, and why Ukraine",
    p1: "This project exists because I feel a calling to share Reiki honestly, from a place of generosity rather than transaction. The universal life energy is not mine to sell. My time, my care, my presence — those I gladly offer, and right now I offer them without a price.",
    p2: "By practising freely, I build genuine experience, real relationships, and a foundation of trust that a future high-end Sunbraider practice can grow from without shortcuts.",
    p3: "At the same time, this project is dedicated to Ukraine. Whenever possible I direct awareness, care, and support to Ukraine and to initiatives like Dzyga's Paw. If a body can be helped to find peace, then perhaps a country can too — one act of presence at a time.",
    p4: "None of the future wellness-clinic services, product lines, or energy-work programmes are active yet. They are quietly being prepared, with respect for the process and for the education I will complete in 2029.",
    dzyga_cta: "Support Dzyga's Paw",
  },
  book: {
    eyebrow: "Book a session",
    title: "A grounded, home-based Reiki experience",
    lede:
      "The session itself has a real Reiki price. **80% of that price is transferred to Ukraine (via Dzyga's Paw); 20% supports my path** — you can see every transfer proof on the fundraiser page. Every session is currently chair Reiki in your home; full-table sessions will follow once I have a portable massage table.",
    name: "Full name",
    email: "Email",
    phone: "Phone",
    address: "Address for the session",
    setup: "Session setup",
    setup_chair: "Chair Reiki at home (default)",
    setup_bed: "High bed at your home",
    setup_table: "Massage table at your home",
    lang: "Preferred language during the session",
    date: "Preferred date",
    time: "Preferred time",
    notes: "Notes (optional)",
    submit: "Request session",
    success_title: "Your session request has been received",
    success_body: "You will receive a confirmation soon. Thank you for trusting this practice.",
  },
  future_interest: {
    eyebrow: "Future interest",
    title: "Be part of what is coming",
    lede:
      "If you feel called to learn Reiki with me later, or to experience the future beauty + Reiki offerings, register your interest here. You'll earn points that later become gifts, discounts and Reiki merchandise.",
    interest_teaching: "Reiki teaching (levels I–III)",
    interest_embodiment: "Reiki embodiment courses",
    interest_beauty: "Sunbraider Wellness Clinic (emotional wellbeing)",
    interest_products: "Curated & self-developed products",
    interest_other: "Other future offering",
    submit: "Register my interest",
    success: "Thank you — your interest has been registered.",
    points_note:
      "Registered supporters earn a welcome bonus and additional points for each interest they register. Rewards will be available when the future programmes launch.",
  },
  future: {
    eyebrow: "Coming later",
    title: "Energy work & the Sunbraider Wellness Clinic",
    lede:
      "The offerings below are not yet active. They form the wider Sunbraider arc: deep energy work, and a wellness clinic focused on emotional wellbeing — so the invitation is not to polish the cracks, but to genuinely become a glowing human being.",
    coming_later: "Coming later",
  },
  certificates: {
    eyebrow: "Trust & credentials",
    title: "Certificates and trainings",
    empty: "Certificates will be published here soon.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Get in touch",
    postal_title: "Postal address (correspondence only)",
    postal_body: "Walstraat 58, 7411 GN Deventer — this is a postal address for Sunbraider, not a visit address.",
    visit_title: "Visit context",
    visit_body:
      "The address above is also a visit address only in the context of T Cocon Deventer Magnesium Floating. For everything else it is post only.",
    phone: "Phone",
    email: "Email",
    form_title: "Send a message",
    name: "Your name",
    subject: "Subject",
    message: "Message",
    submit: "Send message",
    success: "Thank you — your message has been sent.",
  },
  auth: {
    login_title: "Sign in",
    register_title: "Create an account",
    email: "Email",
    password: "Password",
    name: "Full name",
    preferred_language: "Preferred language",
    submit_login: "Sign in",
    submit_register: "Create account",
    or: "or",
    or_email: "or continue with email",
    google_continue: "Continue with Google",
    google_signup: "Sign up with Google",
    have_account: "Already have an account?",
    no_account: "New to Sunbraider?",
  },
  dashboard: {
    title: "My account",
    points: "My points",
    events: "Points history",
    welcome: "Welcome back",
    logout: "Sign out",
    admin_shortcut: "Go to admin",
  },
  admin: {
    title: "Admin dashboard",
    stats: "Overview",
    bookings: "Bookings",
    interest: "Interest signups",
    users: "Users & points",
    certs: "Certificates",
    offerings: "Future offerings",
    services: "Services",
    fundraiser: "Fundraiser",
    gifts: "Gift offers",
    merch: "Merch waitlist",
    emails: "Email queue",
    settings: "Voice & contact",
    availability: "Availability",
    contact: "Messages",
    export: "Export CSV",
  },
  common: {
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    add: "Add",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    free: "Free",
    footer_rights: "© Sunbraider — Reiki for Ukraine. Offered with care.",
  },
};
en.booking = {
  choose_slot: "Choose an available time",
  no_slots: "There are no open sessions yet. Follow me or check back soon.",
  duration_note: "Each session is around 30–45 minutes including a short intro and closing conversation.",
  travel_note: "Sessions outside Deventer need reimbursement of my travel expenses — this will be settled after the appointment is made. To keep the trip workable, an out-of-town booking will be the only session of that day.",
  payment_title: "How will you pay?",
  payment_cash: "Cash — during the session",
  payment_ideal: "iDEAL — before the session",
  payment_bank: "Bank transfer to Triodos",
  payment_note_default: "The session invitation email will include Isa's IBAN and a payment reference.",
  contact_help: "Questions? Message on Signal or email — I answer personally.",
  bring_light: "The first booking brings Ukraine, you and me into the light.",
};
en.contact_extra = {
  signal: "Signal",
  signal_msg: "Hello Isa, I have a question about a Reiki session.",
};
en.pricing = {
  eyebrow: "About the price",
  title: "The sessions aren't really free — 80% goes to Ukraine, 20% supports my path.",
  body:
    "The session itself has a real Reiki price. Of every euro you pay, 80% is transferred to Ukraine (via Dzyga's Paw) and 20% supports my path so I can keep offering this work — food, transport, materials. This isn't hidden overhead; it's honest exchange. Every transfer is shown on this page.",
  send_note: "80% to Ukraine · 20% supports Isa's path.",
  see_proof: "See transfer proofs",
};
en.fundraiser = {
  eyebrow: "Full transparency",
  title: "80% of every euro — sent to Ukraine.",
  lede:
    "Below is the running total and the actual proof screenshots of every transfer sent from Sunbraider to Ukraine and to Dzyga's Paw. Nothing hidden, nothing rounded.",
  total_sent: "Total sent to Ukraine",
  no_entries: "No transfers here yet. Book your session and be the first to bring Ukraine, yourself, and me into the light.",
  received: "Sent on",
  reference: "Reference",
  source: "Source",
  proof: "Transfer proof",
  cta_book: "Book a session — send more to Ukraine",
};
en.dzyga_manifesto = {
  eyebrow: "Why we support the defenders",
  title: "Why we chose military aid",
  intro: "Dzyga's Paw's primary focus is to supply Ukrainian defenders with high-tech equipment so they can do their work more efficiently and more safely. It is a fair question — why support the war effort instead of humanitarian aid?",
  paragraphs: [
    "The leading cause of the humanitarian crisis was Russia's full-scale invasion. After 24 February 2022, more than 14 million Ukrainians had to leave their homes; almost half became internally displaced, the rest went abroad.",
    "As a result of hostilities, many people lost their homes, jobs and ability to provide for themselves. Many territories are mined, unsuitable for farming and food production.",
    "It is very hard to rebuild while military operations continue. If we don't help the military, the threat to the lives and wellbeing of Ukrainians will only grow. Humanitarian assistance can solve short-term problems — housing, food, care for the wounded — but it cannot prevent new dangers from Russia.",
    "The main idea is to push Russian invaders off Ukrainian borders so they no longer wish to return. Then the humanitarian work becomes much more possible, and we would gladly put our energy there too.",
    "That is why Dzyga's Paw focuses on high-tech equipment: Starlinks, drones, long-range encrypted radios, advanced night vision. They have already raised and delivered equipment worth close to $1,500,000. Such gear gives the Ukrainian military a tactical advantage and helps our heroes come home safe.",
    "Supporting both humanitarian and military-focused funds is essential to help Ukrainians deal with war-caused damage. Every contribution is literally saving lives and defending Ukrainian freedom. Thank you for being responsible. Let's not stop helping — as much as we all can.",
  ],
};
en.share = {
  label: "Share the mission",
  copy: "Copy link",
  copied: "Link copied",
  message:
    "Reiki for Ukraine by Sunbraider — sessions in which 80% of the fee is sent to Ukraine and 20% supports the practice. Come with me:",
};
en.support = {
  eyebrow: "Reciprocity",
  title: "Feed the practice — varenyky & borch welcome.",
  lede:
    "Reiki flows both ways. When you receive a session, you are already giving something back — but if you feel called to give more concretely, you are warmly invited to offer me varenyky, borch, or another small gift. This is not a fee. It is the natural circle of care.",
  why_title: "Why this matters",
  why_body:
    "Reiki is not extractive. It benefits me too. Your presence, your kitchen, your soup — all of it nourishes the practice. Please feel free.",
  form_title: "Offer a gift",
  gift_type: "What you'd like to offer",
  gift_pierogi: "Varenyky (dumplings)",
  gift_borscht: "Borch (beet soup)",
  gift_other: "Something else",
  quantity: "Quantity or portion size",
  when: "When you'd like to give it",
  notes: "Notes (optional)",
  submit: "Offer this gift",
  success: "Thank you — your offer has been received.",
  no_pressure: "There is absolutely no pressure. This page exists because guests kept asking.",
};

// Dutch
const nl = {
  brand: { name: "Sunbraider", project: "Reiki voor Oekraïne" },
  nav: {
    home: "Home",
    reiki: "Wat is Reiki",
    mission: "Missie & Oekraïne",
    fundraiser: "Fondsenwerving",
    book: "Sessie boeken",
    support: "Steun Isa",
    future_services: "Toekomstige diensten",
    future_interest: "Toekomstige interesse",
    certificates: "Certificaten",
    contact: "Contact",
    explore: "Ontdek",
    promo: "Promotiemateriaal",
    login: "Inloggen",
    register: "Account aanmaken",
    dashboard: "Mijn account",
    admin: "Beheer",
    logout: "Uitloggen",
    book_cta: "Sessie boeken",
  },
  home: {
    eyebrow: "Een Sunbraider-begin",
    title_line1: "Reiki, ten dienste van Oekraïne.",
    title_line2: "80% gaat door naar Oekraïne.",
    lede:
      "Dit is het eerste hoofdstuk van Sunbraider: een missiegedreven Reiki-praktijk vanuit aanwezigheid, integriteit en compassie. Elke sessie heeft een reële Reiki-prijs — **80% gaat naar Oekraïne (via Dzyga's Paw); 20% ondersteunt mijn pad zodat ik dit werk kan blijven aanbieden**. Levensenergie verkopen resoneert niet; het grootste deel doorsturen wel.",
    cta_book: "Boek een sessie",
    cta_reiki: "Lees: wat is Reiki",
    trust_title: "Een serieus begin van een lange weg",
    trust_body:
      "Sunbraider is mijn persoonlijke praktijk en levensrichting. Nu is het werk bewust kosteloos — om ervaring op te bouwen, aanwezigheid te verdiepen en Oekraïne te steunen. De volgende fases brengen onderwijs, belichaming en een high-end wellness-praktijk — pas wanneer de basis werkelijk klaar is.",
    phases_title: "Drie fases, één weg",
    phase1_title: "Nu — Gratis Reiki & Oekraïne",
    phase1_body: "Gratis Reiki-sessies aan huis. Focus op ervaring, vertrouwen en missie. Steun voor Oekraïne.",
    phase2_title: "Later — Onderwijs & leren",
    phase2_body: "Reiki-onderwijs en belichamingscursussen. Vroege supporters verzamelen punten die later bruikbare cadeaus en Sunbraider-merchandise worden — geen kortingen, want de praktijk verdient het serieus genomen te worden.",
    phase3_title: "Veel later — Sunbraider Wellness Clinic",
    phase3_body: "Een welzijnskliniek gericht op emotioneel welzijn — energiewerk, NEI biotensor, lichte acupunctuur, massage, en gezichts-, haar- en handbehandelingen. Reiki en andere energetische healing worden dan tegen de volle prijs aangeboden zodat het bedrijf op eigen benen kan staan. Onze steun aan Oekraïne blijft doorlopen — we houden iedereen op de hoogte van elke donatie en elke inspanning. Geen glow-up die je draagt, een glow-up die je wórdt.",
    ukraine_title: "Naast Oekraïne staan",
    ukraine_body:
      "Als Reiki een taal van harmonie is, dan zijn vrede en vrijheid haar natuurlijke bodem. In samenwerking met Dzyga's Paw reist een deel van elke sessie door naar Oekraïne, zodat harmonie ergens op kan staan.",
    ukraine_cta: "Lees over de missie",
    certificates_teaser: "Opgeleid, getoetst en toegewijd",
    certificates_teaser_body: "Een galerij van certificaten en trainingen — omdat vertrouwen wordt opgebouwd met transparantie.",
    certificates_cta: "Bekijk certificaten",
  },
  reiki: {
    eyebrow: "Een levende praktijk",
    title: "Wat is Reiki",
    intro:
      "Reiki is de universele levensenergie die door alles wat leeft, ademt en rust beweegt. Reiki beoefenen is niets nieuws uitvinden — het is herinneren wat al stroomt, en die stroom weer helderder toestaan.",
    sections: [
      { h: "Tussen contrast en eenheid", p: "Alles wat we ervaren komt tot ons door contrast — licht en schaduw, geluid en stilte, spanning en ontspanning. Reiki is niet het verwijderen van contrast. Het is de voelbare herinnering dat onder elke polariteit één doorgaand veld ligt. Wanneer het lichaam dat herinnert, ontspant het vanzelf." },
      { h: "Het lichaam als luisterend veld", p: "Ons lichaam is meer dan weefsel — het is een intelligent, gevoelig, energetisch veld. Stress leert ons pantseren; aanwezigheid leert ons openen. In een Reiki-sessie krijgt het lichaam de ruimte om zijn afweer neer te leggen zonder zich te hoeven verklaren." },
      { h: "Aanwezigheid, aanraking en rust", p: "Er is een vorm van aanraking die niet neemt, en een vorm van aanwezigheid die niet vraagt. Reiki wordt vanuit die plek aangeboden. Soms rusten de handen licht op de schouders, soms zweven ze, soms is er enkel de kwaliteit van aandacht — altijd zonder agenda." },
      { h: "Een manier van leven, geen techniek", p: "Reiki is niet enkel iets wat je een uur doet. Het is een houding tegenover het leven — bereidheid om met wat er is te zijn, vertrouwen in de intelligentie van de stroom, en handelen vanuit rust in plaats van haast. Daarom zijn mijn sessies nu gratis: de praktijk voedt mij al." },
      { h: "Een stille herinnering", p: "Elke sessie is een klein herinneren — aan harmonie, verbondenheid, en het feit dat het wezenlijke in ons nooit gebroken was, alleen moe. Dat is de uitnodiging die ik je aanbied, in dit eerste hoofdstuk van Sunbraider." },
    ],
  },
  mission: {
    eyebrow: "De missie",
    title: "Waarom gratis, waarom nu, en waarom Oekraïne",
    p1: "Dit project bestaat omdat ik een roeping voel om Reiki eerlijk te delen, vanuit vrijgevigheid in plaats van transactie. De universele levensenergie is niet van mij om te verkopen. Mijn tijd, mijn zorg, mijn aanwezigheid — die geef ik graag, en nu geef ik ze zonder prijs.",
    p2: "Door vrijelijk te oefenen bouw ik echte ervaring, echte relaties en een fundament van vertrouwen op waaruit een toekomstige high-end Sunbraider-praktijk kan groeien zonder sluipwegen.",
    p3: "Tegelijk is dit project toegewijd aan Oekraïne. Waar mogelijk richt ik bewustwording, zorg en steun naar Oekraïne en initiatieven als Dzyga's Paw. Als een lichaam vrede kan hervinden, kan een land dat misschien ook — één daad van aanwezigheid tegelijk.",
    p4: "Geen enkele toekomstige welzijnskliniek-dienst, productlijn of energiewerk-programma is al actief. Ze worden stil voorbereid, met respect voor het proces en voor de opleiding die ik in 2029 afrond.",
    dzyga_cta: "Steun Dzyga's Paw",
  },
  book: {
    eyebrow: "Boek een sessie",
    title: "Een geaarde, huiselijke Reiki-ervaring",
    lede:
      "De sessie zelf heeft een reële Reiki-prijs. **80% van die prijs gaat naar Oekraïne (via Dzyga's Paw); 20% ondersteunt mijn pad** — elk bewijs zie je op de fondsenwerving-pagina. Elke sessie is nu stoel-Reiki bij jou thuis; volle-tafel-sessies volgen zodra ik een draagbare massagetafel heb.",
    name: "Volledige naam",
    email: "E-mail",
    phone: "Telefoon",
    address: "Adres voor de sessie",
    setup: "Sessie-opstelling",
    setup_chair: "Stoel-Reiki thuis (standaard)",
    setup_bed: "Hoog bed bij jou thuis",
    setup_table: "Massagetafel bij jou thuis",
    lang: "Voorkeurstaal tijdens de sessie",
    date: "Voorkeursdatum",
    time: "Voorkeurstijd",
    notes: "Notities (optioneel)",
    submit: "Sessie aanvragen",
    success_title: "Je aanvraag is ontvangen",
    success_body: "Je ontvangt spoedig een bevestiging. Dank voor het vertrouwen in deze praktijk.",
  },
  future_interest: {
    eyebrow: "Toekomstige interesse",
    title: "Wees deel van wat komt",
    lede:
      "Als je later met mij Reiki wilt leren of de toekomstige beauty + Reiki-diensten wilt ervaren, laat hier je interesse achter. Je verzamelt punten die later cadeaus, kortingen en merchandise worden.",
    interest_teaching: "Reiki-onderwijs (niveau I–III)",
    interest_embodiment: "Reiki belichamingscursussen",
    interest_beauty: "Sunbraider Wellness Clinic (emotioneel welzijn)",
    interest_products: "Zorgvuldig gekozen & zelf-ontwikkelde producten",
    interest_other: "Andere toekomstige dienst",
    submit: "Registreer mijn interesse",
    success: "Dank je — je interesse is geregistreerd.",
    points_note:
      "Geregistreerde supporters krijgen een welkomstbonus en extra punten per interesse. Beloningen worden beschikbaar zodra de toekomstige programma's starten.",
  },
  future: {
    eyebrow: "Komt later",
    title: "Energiewerk & de Sunbraider Wellness Clinic",
    lede:
      "De onderstaande diensten zijn nog niet actief. Ze vormen de bredere Sunbraider-boog: diep energiewerk en een welzijnskliniek gericht op emotioneel welzijn — niet de scheuren oppoetsen, maar echt een stralend mens wórden.",
    coming_later: "Komt later",
  },
  certificates: {
    eyebrow: "Vertrouwen & referenties",
    title: "Certificaten en trainingen",
    empty: "Certificaten worden hier binnenkort gepubliceerd.",
  },
  contact: {
    eyebrow: "Contact",
    title: "Neem contact op",
    postal_title: "Postadres (alleen correspondentie)",
    postal_body: "Walstraat 58, 7411 GN Deventer — dit is een postadres voor Sunbraider, geen bezoekadres.",
    visit_title: "Bezoekcontext",
    visit_body:
      "Bovenstaand adres is enkel bezoekadres in de context van T Cocon Deventer Magnesium Floating. Voor al het andere is het uitsluitend post.",
    phone: "Telefoon",
    email: "E-mail",
    form_title: "Stuur een bericht",
    name: "Je naam",
    subject: "Onderwerp",
    message: "Bericht",
    submit: "Bericht versturen",
    success: "Dank je — je bericht is verstuurd.",
  },
  auth: {
    login_title: "Inloggen",
    register_title: "Account aanmaken",
    email: "E-mail",
    password: "Wachtwoord",
    name: "Volledige naam",
    preferred_language: "Voorkeurstaal",
    submit_login: "Inloggen",
    submit_register: "Account aanmaken",
    or: "of",
    or_email: "of ga verder met e-mail",
    google_continue: "Doorgaan met Google",
    google_signup: "Aanmelden met Google",
    have_account: "Heb je al een account?",
    no_account: "Nieuw bij Sunbraider?",
  },
  dashboard: {
    title: "Mijn account",
    points: "Mijn punten",
    events: "Puntenhistorie",
    welcome: "Welkom terug",
    logout: "Uitloggen",
    admin_shortcut: "Naar beheer",
  },
  admin: {
    title: "Beheer-dashboard",
    stats: "Overzicht",
    bookings: "Boekingen",
    interest: "Interesse-aanmeldingen",
    users: "Gebruikers & punten",
    certs: "Certificaten",
    offerings: "Toekomstige diensten",
    services: "Diensten",
    fundraiser: "Fondsenwerving",
    gifts: "Cadeau-aanbiedingen",
    merch: "Merch-wachtlijst",
    emails: "E-mailwachtrij",
    settings: "Stem & contact",
    availability: "Beschikbaarheid",
    contact: "Berichten",
    export: "CSV exporteren",
  },
  common: {
    loading: "Laden...",
    cancel: "Annuleren",
    save: "Opslaan",
    delete: "Verwijderen",
    add: "Toevoegen",
    edit: "Bewerken",
    close: "Sluiten",
    confirm: "Bevestigen",
    free: "Gratis",
    footer_rights: "© Sunbraider — Reiki voor Oekraïne. Met zorg aangeboden.",
  },
};
nl.booking = {
  choose_slot: "Kies een beschikbaar tijdstip",
  no_slots: "Er zijn nog geen open sessies. Volg mij of kom binnenkort terug.",
  duration_note: "Elke sessie duurt ongeveer 30–45 minuten inclusief een kort voor- en nagesprek.",
  travel_note: "Sessies buiten Deventer vragen om vergoeding van mijn reiskosten — dit wordt na het maken van de afspraak afgehandeld. Om de reis werkbaar te houden, is een buiten-Deventer-boeking de enige sessie van die dag.",
  payment_title: "Hoe betaal je?",
  payment_cash: "Contant — tijdens de sessie",
  payment_ideal: "iDEAL — vóór de sessie",
  payment_bank: "Bankoverschrijving naar Triodos",
  payment_note_default: "De bevestigingsmail bevat Isa's IBAN en een betalingsreferentie.",
  contact_help: "Vragen? Stuur een berichtje via Signal of e-mail — ik antwoord persoonlijk.",
  bring_light: "De eerste boeking brengt Oekraïne, jou en mij naar het licht.",
};
nl.contact_extra = {
  signal: "Signal",
  signal_msg: "Hoi Isa, ik heb een vraag over een Reiki-sessie.",
};
nl.pricing = {
  eyebrow: "Over de prijs",
  title: "De sessies zijn niet echt gratis — 80% gaat naar Oekraïne, 20% ondersteunt mijn pad.",
  body:
    "De sessie zelf heeft een reële Reiki-prijs. Van elke euro die je betaalt gaat 80% naar Oekraïne (via Dzyga's Paw) en 20% ondersteunt mijn pad zodat ik dit werk kan blijven aanbieden — eten, vervoer, materiaal. Geen verborgen overhead; eerlijk uitwisselen. Elke overschrijving zie je op deze pagina.",
  send_note: "80% naar Oekraïne · 20% ondersteunt Isa's pad.",
  see_proof: "Bekijk bewijs van overschrijvingen",
};
nl.fundraiser = {
  eyebrow: "Volledige transparantie",
  title: "80% van elke euro — naar Oekraïne.",
  lede:
    "Hieronder de lopende telling en de echte screenshots van elke overschrijving vanuit Sunbraider naar Oekraïne en Dzyga's Paw. Niets verborgen, niets afgerond.",
  total_sent: "Totaal naar Oekraïne",
  no_entries: "Nog geen overschrijvingen hier. Boek jouw sessie en wees de eerste die zowel Oekraïne, jezelf als mij naar het licht brengt.",
  received: "Verzonden op",
  reference: "Referentie",
  source: "Bron",
  proof: "Bewijs van overschrijving",
  cta_book: "Boek een sessie — stuur meer naar Oekraïne",
};
nl.dzyga_manifesto = {
  eyebrow: "Waarom we de verdedigers steunen",
  title: "Waarom we voor militaire steun kiezen",
  intro: "Dzyga's Paw richt zich er in eerste instantie op om Oekraïense verdedigers te voorzien van hightech uitrusting zodat ze hun werk efficiënter én veiliger kunnen doen. Een terechte vraag: waarom de oorlogsinspanning steunen in plaats van alleen humanitaire hulp?",
  paragraphs: [
    "De hoofdoorzaak van de humanitaire crisis was Ruslands grootschalige invasie. Na 24 februari 2022 moesten meer dan 14 miljoen Oekraïners hun huis verlaten; bijna de helft werd intern ontheemd, de rest ging het buitenland in.",
    "Door de vijandelijkheden verloren veel mensen hun huis, werk en het vermogen om in hun eigen levensonderhoud te voorzien. Grote gebieden zijn ondermijnd en ongeschikt voor landbouw en voedselproductie.",
    "Herstel is bijna onmogelijk zolang de militaire operaties doorgaan. Zonder militaire steun groeit de dreiging voor levens en welzijn van Oekraïners. Humanitaire hulp lost kortetermijnproblemen op — onderdak, voedsel, zorg voor gewonden — maar keert geen nieuwe Russische dreiging.",
    "Het idee is om Russische indringers van de Oekraïense grenzen te duwen zodat ze niet meer terug willen komen. Daarna wordt humanitair werk veel haalbaarder — en dáár leggen we graag onze energie later.",
    "Daarom focust Dzyga's Paw op hightech uitrusting: Starlinks, drones, versleutelde langeafstandsradio's, geavanceerde nachtzicht-apparatuur. Ze hebben al bijna $1.500.000 aan uitrusting opgehaald en geleverd. Dit geeft het Oekraïense leger een tactisch voordeel en helpt onze helden veilig thuis te komen.",
    "Zowel humanitaire als militaire steun is essentieel om Oekraïners te helpen met de oorlogsschade. Elke bijdrage redt letterlijk levens en verdedigt Oekraïense vrijheid. Dank aan iedereen die verantwoordelijkheid neemt. Laten we niet stoppen met helpen — zoveel als we allemaal kunnen.",
  ],
};
nl.share = {
  label: "Deel de missie",
  copy: "Kopieer link",
  copied: "Link gekopieerd",
  message:
    "Reiki voor Oekraïne door Sunbraider — sessies waarvan 80% naar Oekraïne gaat en 20% de praktijk ondersteunt. Ga mee:",
};
nl.support = {
  eyebrow: "Wederkerigheid",
  title: "Voed de praktijk — varenyky & borch welkom.",
  lede:
    "Reiki stroomt in beide richtingen. Als je een sessie ontvangt, geef je al iets terug — maar als je iets concreets wil geven, ben je van harte uitgenodigd om varenyky, borch of een ander klein cadeau aan te bieden. Dit is geen betaling. Het is de natuurlijke kring van zorg.",
  why_title: "Waarom dit ertoe doet",
  why_body:
    "Reiki is niet extractief. Het doet mij ook goed. Jouw aanwezigheid, jouw keuken, jouw soep — het voedt de praktijk. Voel je vrij.",
  form_title: "Bied een cadeau aan",
  gift_type: "Wat wil je aanbieden",
  gift_pierogi: "Varenyky (deegwaren)",
  gift_borscht: "Borch (bietensoep)",
  gift_other: "Iets anders",
  quantity: "Hoeveelheid of portie",
  when: "Wanneer je het wil geven",
  notes: "Notities (optioneel)",
  submit: "Bied dit cadeau aan",
  success: "Dank je — je aanbod is ontvangen.",
  no_pressure: "Er is absoluut geen druk. Deze pagina bestaat omdat gasten er om bleven vragen.",
};


// Ukrainian
const uk = {
  brand: { name: "Sunbraider", project: "Рейкі для України" },
  nav: {
    home: "Головна",
    reiki: "Що таке Рейкі",
    mission: "Місія та Україна",
    fundraiser: "Збір коштів",
    book: "Записатися",
    support: "Підтримати Ісу",
    future_services: "Майбутні пропозиції",
    future_interest: "Майбутній інтерес",
    certificates: "Сертифікати",
    contact: "Контакти",
    explore: "Дослідити",
    promo: "Промоматеріали",
    login: "Увійти",
    register: "Створити акаунт",
    dashboard: "Мій акаунт",
    admin: "Адмін",
    logout: "Вийти",
    book_cta: "Записатися",
  },
  home: {
    eyebrow: "Початок Sunbraider",
    title_line1: "Рейкі — на службі Україні.",
    title_line2: "80% далі в Україну.",
    lede:
      "Це перший розділ Sunbraider — місіонерська практика Рейкі, вкорінена у присутності, чесності та співчутті. Кожен сеанс має реальну ціну Рейкі — **80% переказується в Україну (через Dzyga's Paw); 20% підтримує мій шлях, щоб я могла продовжувати цю роботу**. Продавати саму життєву енергію мені не резонує; переказувати більшу частину далі — резонує.",
    cta_book: "Записатися на сеанс",
    cta_reiki: "Читати: що таке Рейкі",
    trust_title: "Серйозний початок довгого шляху",
    trust_body:
      "Sunbraider — моя особиста практика і напрямок життя. Зараз робота свідомо безкоштовна — щоб набути досвід, поглибити присутність і підтримати Україну. Наступні етапи принесуть навчання, втілення і преміальну велнес-практику — але лише коли ґрунт справді буде готовий.",
    phases_title: "Три етапи, один шлях",
    phase1_title: "Зараз — Безкоштовне Рейкі та Україна",
    phase1_body: "Безкоштовні сеанси Рейкі вдома. Досвід, довіра, місія. Підтримка України.",
    phase2_title: "Пізніше — Навчання",
    phase2_body: "Курси Рейкі та втілення. Ранні прихильники накопичують бали, які пізніше стають корисними подарунками та мерчем Sunbraider — без знижок, бо практика заслуговує серйозного ставлення.",
    phase3_title: "Значно пізніше — Sunbraider Wellness Clinic",
    phase3_body: "Клініка велнесу з фокусом на емоційному благополуччі — енергетична робота, NEI біотензор, легка акупунктура, масаж, догляд за обличчям, волоссям і руками. Рейкі та інші види енергетичного зцілення тоді пропонуються за повною ціною, щоб бізнес стояв на власних ногах. Наша підтримка України триває — ми тримаємо всіх у курсі кожної пожертви й кожного зусилля. Не сяйво, яке ви носите, а сяйво, яким ви стаєте.",
    ukraine_title: "Разом з Україною",
    ukraine_body:
      "Якщо Рейкі — це мова гармонії, то мир і свобода — її природний ґрунт. У співпраці з Dzyga's Paw частина кожного сеансу подорожує далі в Україну, щоб гармонія мала на чому стояти.",
    ukraine_cta: "Дізнатися про місію",
    certificates_teaser: "Навчений, підтверджений, відданий",
    certificates_teaser_body: "Галерея сертифікатів і навчань — довіра будується на прозорості.",
    certificates_cta: "Переглянути сертифікати",
  },
  reiki: {
    eyebrow: "Жива практика",
    title: "Що таке Рейкі",
    intro:
      "Рейкі — це універсальна життєва енергія, що рухається крізь усе живе, дихаюче і спочиваюче. Практикувати Рейкі — не винаходити нове; це пригадувати те, що вже тече, і дозволяти йому текти чіткіше.",
    sections: [
      { h: "Між контрастом і єдністю", p: "Все, що ми переживаємо, приходить крізь контраст — світло і тінь, звук і тишу, напругу і спокій. Рейкі не прибирає контрасту. Це відчутне пригадування, що під кожною полярністю лежить одне безперервне поле. Коли тіло згадує це — воно розслаблюється саме." },
      { h: "Тіло як слухаюче поле", p: "Наше тіло — не лише тканини; це розумне, чутливе, енергетичне поле. Стрес вчить нас захищатися; присутність вчить відкриватися. У сеансі Рейкі тіло отримує простір відкласти оборону, не пояснюючи її." },
      { h: "Присутність, дотик і спокій", p: "Існує дотик, що не бере, і присутність, що не вимагає. Рейкі пропонується саме звідти. Іноді долоні легко лежать на плечах, іноді парять, іноді є лише якість уваги — завжди без порядку денного." },
      { h: "Спосіб життя, а не техніка", p: "Рейкі — не лише те, що ти робиш годину. Це постава щодо життя — готовність бути з тим, що є, довіряти розумові потоку і рухатися зі спокою, а не з поспіху. Тому мої нинішні сеанси безкоштовні: практика вже живить мене." },
      { h: "Тихе пригадування", p: "Кожен сеанс — маленьке пригадування — гармонії, зв'язку і того, що суттєве в нас ніколи не зламано, лише втомлено. Це запрошення, яке я тобі роблю у першому розділі Sunbraider." },
    ],
  },
  mission: {
    eyebrow: "Місія",
    title: "Чому безкоштовно, чому зараз і чому Україна",
    p1: "Цей проєкт існує, бо я відчуваю покликання ділитися Рейкі чесно, з місця щедрості, а не транзакції. Універсальна життєва енергія — не моя, щоб продаватися. Мій час, моя турбота, моя присутність — це я радо віддаю, і зараз віддаю без ціни.",
    p2: "Практикуючи вільно, я будую справжній досвід, справжні стосунки та підмурівок довіри, з якого зможе рости майбутня преміум-практика Sunbraider без короткого шляху.",
    p3: "Водночас цей проєкт присвячений Україні. Коли можливо, я спрямовую увагу, турботу і підтримку до України та ініціатив як Dzyga's Paw. Якщо тіло може повернутися до миру — можливо, може і країна, одним актом присутності за раз.",
    p4: "Жоден із майбутніх сервісів клініки велнесу, продуктових ліній чи енергетичних програм наразі не активний. Вони тихо готуються, з повагою до процесу та до освіти, яку я завершу у 2029.",
    dzyga_cta: "Підтримати Dzyga's Paw",
  },
  book: {
    eyebrow: "Записатися",
    title: "Земне домашнє Рейкі",
    lede:
      "Сам сеанс має реальну ціну Рейкі. **80% цієї ціни переказується в Україну (через Dzyga's Paw); 20% підтримує мій шлях** — усі докази ви побачите на сторінці збору коштів. Наразі кожен сеанс — це Рейкі на стільці у вас удома; повноцінні сеанси на столі почнуться, коли я матиму портативний масажний стіл.",
    name: "Повне ім'я",
    email: "E-mail",
    phone: "Телефон",
    address: "Адреса для сеансу",
    setup: "Формат сеансу",
    setup_chair: "Рейкі на стільці вдома (типово)",
    setup_bed: "Високе ліжко у вас удома",
    setup_table: "Масажний стіл у вас удома",
    lang: "Мова під час сеансу",
    date: "Бажана дата",
    time: "Бажаний час",
    notes: "Нотатки (необов'язково)",
    submit: "Запитати сеанс",
    success_title: "Ваш запит отримано",
    success_body: "Ви незабаром отримаєте підтвердження. Дякую за довіру.",
  },
  future_interest: {
    eyebrow: "Майбутній інтерес",
    title: "Будьте частиною того, що прийде",
    lede:
      "Якщо ви відчуваєте покликання пізніше вчити Рейкі зі мною або скористатися майбутніми beauty + Рейкі послугами, залиште інтерес. Ви отримаєте бали, що пізніше стануть подарунками, знижками та мерчем.",
    interest_teaching: "Навчання Рейкі (рівні I–III)",
    interest_embodiment: "Курси втілення Рейкі",
    interest_beauty: "Sunbraider Wellness Clinic (емоційне благополуччя)",
    interest_products: "Дбайливо підібрані та власні продукти",
    interest_other: "Інша майбутня пропозиція",
    submit: "Зареєструвати інтерес",
    success: "Дякую — ваш інтерес зареєстровано.",
    points_note:
      "Зареєстровані прихильники отримують вітальний бонус та додаткові бали за кожен інтерес. Винагороди стануть доступні при запуску програм.",
  },
  future: {
    eyebrow: "Прийде пізніше",
    title: "Енергетична робота та Sunbraider Wellness Clinic",
    lede:
      "Пропозиції нижче ще не активні. Вони формують ширшу дугу Sunbraider: глибока енергетична робота та клініка велнесу з фокусом на емоційному благополуччі — не полірувати тріщини, а справді ставати сяючою людиною.",
    coming_later: "Прийде пізніше",
  },
  certificates: {
    eyebrow: "Довіра та кваліфікація",
    title: "Сертифікати та навчання",
    empty: "Сертифікати з'являться тут незабаром.",
  },
  contact: {
    eyebrow: "Контакти",
    title: "Зв'яжіться",
    postal_title: "Поштова адреса (лише кореспонденція)",
    postal_body: "Walstraat 58, 7411 GN Deventer — це поштова адреса Sunbraider, не адреса візиту.",
    visit_title: "Контекст візиту",
    visit_body:
      "Вказана адреса — це адреса візиту лише в контексті T Cocon Deventer Magnesium Floating. Для іншого — лише пошта.",
    phone: "Телефон",
    email: "E-mail",
    form_title: "Надіслати повідомлення",
    name: "Ваше ім'я",
    subject: "Тема",
    message: "Повідомлення",
    submit: "Надіслати",
    success: "Дякую — ваше повідомлення надіслано.",
  },
  auth: {
    login_title: "Увійти",
    register_title: "Створити акаунт",
    email: "E-mail",
    password: "Пароль",
    name: "Повне ім'я",
    preferred_language: "Бажана мова",
    submit_login: "Увійти",
    submit_register: "Створити",
    or: "або",
    or_email: "або через e-mail",
    google_continue: "Продовжити через Google",
    google_signup: "Зареєструватись через Google",
    have_account: "Вже маєте акаунт?",
    no_account: "Новачок у Sunbraider?",
  },
  dashboard: {
    title: "Мій акаунт",
    points: "Мої бали",
    events: "Історія балів",
    welcome: "Ласкаво просимо",
    logout: "Вийти",
    admin_shortcut: "Перейти до адмін",
  },
  admin: {
    title: "Адмін-панель",
    stats: "Огляд",
    bookings: "Записи",
    interest: "Заявки інтересу",
    users: "Користувачі та бали",
    certs: "Сертифікати",
    offerings: "Майбутні послуги",
    services: "Послуги",
    fundraiser: "Збір коштів",
    gifts: "Подарунки",
    merch: "Список мерчу",
    emails: "Черга e-mail",
    settings: "Голос та контакт",
    availability: "Доступність",
    contact: "Повідомлення",
    export: "Експорт CSV",
  },
  common: {
    loading: "Завантаження...",
    cancel: "Скасувати",
    save: "Зберегти",
    delete: "Видалити",
    add: "Додати",
    edit: "Редагувати",
    close: "Закрити",
    confirm: "Підтвердити",
    free: "Безкоштовно",
    footer_rights: "© Sunbraider — Рейкі для України. З турботою.",
  },
};
uk.booking = {
  choose_slot: "Оберіть доступний час",
  no_slots: "Поки що немає відкритих сеансів. Слідкуйте або поверніться пізніше.",
  duration_note: "Кожен сеанс триває приблизно 30–45 хвилин, включаючи коротке вступне та підсумкове спілкування.",
  travel_note: "Сеанси за межами Девентера потребують відшкодування моїх дорожніх витрат — це буде вирішено після оформлення запису. Щоб поїздка мала сенс, у такий день буде лише один сеанс.",
  payment_title: "Як ви заплатите?",
  payment_cash: "Готівка — під час сеансу",
  payment_ideal: "iDEAL — перед сеансом",
  payment_bank: "Банківський переказ на Triodos",
  payment_note_default: "У листі підтвердження буде IBAN Іси та референс платежу.",
  contact_help: "Питання? Напишіть у Signal або e-mail — я відповідаю особисто.",
  bring_light: "Перше бронювання виведе Україну, вас і мене до світла.",
};
uk.contact_extra = {
  signal: "Signal",
  signal_msg: "Вітаю Ісо, у мене питання щодо сеансу Рейкі.",
};
uk.pricing = {
  eyebrow: "Про ціну",
  title: "Сеанси не зовсім безкоштовні — 80% в Україну, 20% на мій шлях.",
  body:
    "Сам сеанс має реальну ціну Рейкі. З кожного євро, яке ви платите, 80% переказується в Україну (через Dzyga's Paw), а 20% підтримує мій шлях, щоб я могла продовжувати цю роботу — їжа, транспорт, матеріали. Це не прихована націнка; це чесний обмін. Кожен переказ показано на цій сторінці.",
  send_note: "80% в Україну · 20% підтримує шлях Іси.",
  see_proof: "Переглянути докази переказів",
};
uk.fundraiser = {
  eyebrow: "Повна прозорість",
  title: "80% кожного євро — в Україну.",
  lede:
    "Нижче — поточна сума та реальні скріншоти кожного переказу з Sunbraider в Україну та Dzyga's Paw. Нічого прихованого, нічого округленого.",
  total_sent: "Загалом переказано",
  no_entries: "Тут ще немає переказів. Забронюйте сеанс і станьте першим, хто виведе Україну, себе й мене до світла.",
  received: "Надіслано",
  reference: "Референс",
  source: "Джерело",
  proof: "Доказ переказу",
  cta_book: "Записатися — надіслати більше в Україну",
};
uk.dzyga_manifesto = {
  eyebrow: "Чому ми підтримуємо захисників",
  title: "Чому ми обрали військову допомогу",
  intro: "Основний фокус Dzyga's Paw — забезпечувати українських захисників високотехнологічним обладнанням, щоб вони могли виконувати свою роботу ефективніше й безпечніше. Справедливе запитання — чому підтримувати воєнні зусилля, а не лише гуманітарну допомогу?",
  paragraphs: [
    "Головною причиною гуманітарної кризи стало повномасштабне вторгнення Росії. Після 24 лютого 2022 понад 14 мільйонів українців мусили залишити свої домівки; майже половина стала внутрішньо переміщеними, решта — виїхала за кордон.",
    "Через бойові дії багато людей втратили житло, роботу й змогу забезпечувати себе. Значні території заміновані та непридатні для землеробства й вирощування їжі.",
    "Відновлюватися майже неможливо, доки тривають бойові дії. Без військової допомоги загроза життю та добробуту українців лише зростає. Гуманітарна допомога вирішує короткострокові проблеми — житло, їжа, догляд за пораненими — але не запобігає новим небезпекам з боку Росії.",
    "Ідея — відсунути російських загарбників від українських кордонів, щоб вони більше не хотіли повертатись. Тоді гуманітарна робота стає набагато можливішою, і ми з радістю вкладемо енергію туди теж.",
    "Тому Dzyga's Paw зосереджується на високотехнологічному обладнанні: Starlink, дрони, зашифровані рації дальнього зв'язку, сучасні системи нічного бачення. Вони вже зібрали й доставили обладнання майже на $1 500 000. Це дає українським військовим тактичну перевагу й допомагає нашим героям повертатися додому живими.",
    "Підтримка як гуманітарних, так і військових фондів необхідна, щоб українці могли впоратися з наслідками війни. Кожен внесок буквально рятує життя й захищає українську свободу. Дякуємо всім, хто бере відповідальність. Не зупиняймося — стільки, скільки кожен із нас може.",
  ],
};
uk.share = {
  label: "Поширити місію",
  copy: "Копіювати посилання",
  copied: "Посилання скопійовано",
  message:
    "Рейкі для України від Sunbraider — сеанси, де 80% плати йде в Україну і 20% підтримує практику. Приєднуйтесь:",
};
uk.support = {
  eyebrow: "Взаємність",
  title: "Нагодуйте практику — вареники та борщ вітаються.",
  lede:
    "Рейкі тече в обидва боки. Отримуючи сеанс, ви вже даруєте щось у відповідь — але якщо ви хочете дати щось конкретне, ви маєте теплу можливість пригостити мене варениками, борщем чи іншим маленьким подарунком. Це не оплата. Це природне коло турботи.",
  why_title: "Чому це важливо",
  why_body:
    "Рейкі не є експлуатацією. Мені теж від нього стає добре. Ваша присутність, ваша кухня, ваш суп — усе це живить практику. Будь ласка, дійте вільно.",
  form_title: "Запропонувати подарунок",
  gift_type: "Що ви хочете запропонувати",
  gift_pierogi: "Вареники",
  gift_borscht: "Борщ",
  gift_other: "Щось інше",
  quantity: "Кількість або порція",
  when: "Коли б ви хотіли передати",
  notes: "Нотатки (необов'язково)",
  submit: "Запропонувати",
  success: "Дякую — вашу пропозицію отримано.",
  no_pressure: "Абсолютно без тиску. Ця сторінка існує тому, що гості про це самі питали.",
};


export const translations = { en, nl, uk };
